import PersonIcon from '@material-ui/icons/Person';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import DvrIcon from '@material-ui/icons/Dvr';
import HomeIcon from '@material-ui/icons/Home';
import GetAppIcon from '@material-ui/icons/GetApp';
import SubscriptionIcon from '@material-ui/icons/ViewComfy';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import HistoryIcon from '@material-ui/icons/History';

export enum ProductId {
  xmlCompare = 'XML Compare',
  xmlDataCompare = 'XML Data Compare',
  ditaCompare = 'DITA Compare',
  docbookCompare = 'DocBook Compare', 
  xmlMerge = 'XML Merge',
  ditaMerge = 'DITA Merge',
  deltaJson = 'DeltaJSON',
  deltaJsonsaas = 'DeltaJSON SaaS',
  ccS1000D = 'Content Compare S1000D',
  ccJATS = 'Content Compare JATS',
  ccBITS = 'Content Compare BITS',
  ccNISOSTS = 'Content Compare NISO-STS',
  ccXSLFO = 'Content Compare XSL-FO',
  conversionQA = 'ConversionQA',
  linuxLicenseServer = 'Linux License Server',
  windowsLicenseServer = 'Windows License Server',
  macIntelLicenseServer = 'macOS License Server (Intel)',
  macARMLicenseServer = 'macOS License Server (ARM)',
  htmlCompare = 'HTML Compare',
  deltaNova = "DeltaNova",
  deltaInsights = "DeltaInsights",
  oxygenPlugin = "Delta Oxygen Plugin"
}

export interface NavigatorEntry {
  id: string,
  icon: JSX.Element;
  active?: boolean;
  link: string;
  productInfo?: string;
}

export interface NavigatorSection {
  id: string,
  children: NavigatorEntry[]
}

export enum Products {
  xmlCompare = 'xmlcompare',
  xmlDataCompare = 'xmldatacompare',
  ditaCompare = 'ditacompare',
  docbookCompare = 'docbookcompare',
  xmlMerge = 'xmlmerge',
  ditaMerge = 'ditamerge',
  deltaJson = 'deltajson',
  conversionQA = 'conversionQA',
  linuxLicenseServer = 'linuxlicenseserver',
  windowsLicenseServer = 'windowslicenseserver',
  macIntelLicenseServer = 'macintellicenseserver',
  macARMLicenseServer = 'macarmlicenseserver',
  htmlCompare = 'htmlcompare',
  deltaNova = 'deltanova',
  deltaInsights = 'deltainsights',
  oxygenPlugin = 'deltaoxygenplugin'
}

export class NavigatorData {
  
  public static getPathForNavItem(baseUrl: string, itemUrl: string) {
    return baseUrl + '/' + itemUrl;
  }

  public static baseUrl = '/home'
  public static profileBaseUrl = '/profile';
  public static evaluationManagerBaseUrl = '/evaluationManager';
  public static licenseManagerBaseUrl = '/licenseManager';
  public static subscriptionManagerBaseUrl = '/subscriptionManager';
  public static saasProductsBaseUrl = '/saasProduct';
  public static legacyDownloadProductUrl = '/legacyDownloads';
  public static downloadProductUrl = '/downloads';
  public static callbackBaseUrl = '/callback';
  public static callbackBaseSaasUrl = {
    [ProductId.ccS1000D]: '/callbacks1000dsaas',
    [ProductId.ccJATS]: '/callbackjatssaas', 
    [ProductId.ccBITS]: '/callbackbitssaas', 
    [ProductId.ccNISOSTS]: '/callbacknisostssaas',
    [ProductId.ccXSLFO]: '/callbackxslfosaas'
  }
  
  public static RootSectionsAuthenticated: NavigatorSection[] = [
    {
      id: "Account",
      children: [
        { id: 'Home', icon: <HomeIcon />, link: NavigatorData.baseUrl },
        { id: 'Profile', icon: <PersonIcon />, link: NavigatorData.profileBaseUrl },
        { id: 'Evaluation Manager', icon: <DoubleArrowIcon />, link: NavigatorData.evaluationManagerBaseUrl },
        { id: 'License Manager', icon: <VpnKeyIcon />, link: NavigatorData.licenseManagerBaseUrl },
        // { id: 'Subscription Manager', icon: <SubscriptionIcon />, link: NavigatorData.subscriptionManagerBaseUrl },  
        { id: 'Downloads', icon: <GetAppIcon />, link: NavigatorData.downloadProductUrl },
        // { id: 'SaaS Products', icon: <DvrIcon />, link: NavigatorData.saasProductsBaseUrl }
      ],
    },
  ];

  public static DownloadSections: NavigatorEntry[] = [
    { id: ProductId.xmlCompare, productInfo: "https://docs.deltaxignia.com/xml-compare/latest/", icon: <img src="/XMLCompareIcon_White.svg" alt='XML Compare' />, link: NavigatorData.getPathForNavItem(NavigatorData.legacyDownloadProductUrl, Products.xmlCompare) },
    { id: ProductId.xmlDataCompare, productInfo: "https://docs.deltaxignia.com/xml-data-compare/latest/", icon: <img src="/XMLDataCompareIcon_White.svg" alt='XML Data Compare' />, link: NavigatorData.getPathForNavItem(NavigatorData.legacyDownloadProductUrl, Products.xmlDataCompare) },
    { id: ProductId.ditaCompare, productInfo: "https://docs.deltaxignia.com/dita-compare/latest/", icon: <img src="/DITACompareIcon_White.svg" alt='DITA Compare' />, link: NavigatorData.getPathForNavItem(NavigatorData.legacyDownloadProductUrl, Products.ditaCompare) },
    { id: ProductId.docbookCompare, productInfo: "https://docs.deltaxignia.com/docbook-compare/latest/", icon: <img src="/DocBookCompareIcon_White.svg" alt='DocBook Compare' />, link: NavigatorData.getPathForNavItem(NavigatorData.legacyDownloadProductUrl, Products.docbookCompare) },
    { id: ProductId.xmlMerge, productInfo: "https://docs.deltaxignia.com/xml-merge/latest/", icon: <img src="/XMLMergeIcon_White.svg" alt='XML Merge' />, link: NavigatorData.getPathForNavItem(NavigatorData.legacyDownloadProductUrl, Products.xmlMerge) },
    { id: ProductId.ditaMerge, productInfo: "https://docs.deltaxignia.com/dita-merge/latest/", icon: <img src="/DITAMergeIcon_White.svg" alt='DITA Merge' />, link: NavigatorData.getPathForNavItem(NavigatorData.legacyDownloadProductUrl, Products.ditaMerge) },
    { id: ProductId.deltaJson, productInfo: "https://docs.deltaxignia.com/deltajson/latest/", icon: <img src="/DeltaJSONIcon_White.svg" alt='DeltaJSON' />, link: NavigatorData.getPathForNavItem(NavigatorData.legacyDownloadProductUrl, Products.deltaJson) },
    { id: ProductId.conversionQA, productInfo: "https://docs.deltaxignia.com/conversionqa/latest/", icon: <img src="/CQA_Icon.svg" alt='ConversionQA' />, link: NavigatorData.getPathForNavItem(NavigatorData.legacyDownloadProductUrl, Products.conversionQA) },
    { id: ProductId.htmlCompare, productInfo: "https://docs.deltaxignia.com/html-compare/latest/", icon: <img src="/HTMLCompareIcon_DarkBackgrounds.svg" alt='HTML Compare' />, link: NavigatorData.getPathForNavItem(NavigatorData.legacyDownloadProductUrl, Products.htmlCompare) },
    { id: ProductId.deltaNova, productInfo: "", icon: <img src="/Nova_White.svg" alt='Delta Nova' />, link: NavigatorData.getPathForNavItem(NavigatorData.downloadProductUrl, Products.deltaNova) },
    { id: ProductId.deltaInsights, productInfo: "", icon: <img src="/Insights_White.svg" alt='Delta Insights' />, link: NavigatorData.getPathForNavItem(NavigatorData.downloadProductUrl, Products.deltaInsights) },
    { id: ProductId.oxygenPlugin, productInfo: "", icon: <img src="/DeltaXignia_LogoMark_Colour.svg" alt='Oxygen Plugin' />, link: NavigatorData.getPathForNavItem(NavigatorData.downloadProductUrl, Products.oxygenPlugin) },
    { id: ProductId.linuxLicenseServer, productInfo: "https://docs.deltaxignia.com/support-and-documentation/latest/how-to-setup-a-license-server", icon: <img src="/DeltaXignia_LogoMark_Colour.svg" alt='Linux License Server' />, link: NavigatorData.getPathForNavItem(NavigatorData.downloadProductUrl, Products.linuxLicenseServer) },
    { id: ProductId.windowsLicenseServer, productInfo: "https://docs.deltaxignia.com/support-and-documentation/latest/how-to-setup-a-license-server", icon: <img src="/DeltaXignia_LogoMark_Colour.svg" alt='Windows License Server' />, link: NavigatorData.getPathForNavItem(NavigatorData.downloadProductUrl, Products.windowsLicenseServer) },
    { id: ProductId.macIntelLicenseServer, productInfo: "https://docs.deltaxignia.com/support-and-documentation/latest/how-to-setup-a-license-server", icon: <img src="/DeltaXignia_LogoMark_Colour.svg" alt='macOS License Server (Intel)' />, link: NavigatorData.getPathForNavItem(NavigatorData.downloadProductUrl, Products.macIntelLicenseServer) },
    { id: ProductId.macARMLicenseServer, productInfo: "https://docs.deltaxignia.com/support-and-documentation/latest/how-to-setup-a-license-server", icon: <img src="/DeltaXignia_LogoMark_Colour.svg" alt='macOS License Server (ARM)' />, link: NavigatorData.getPathForNavItem(NavigatorData.downloadProductUrl, Products.macARMLicenseServer) },
    { id: 'Legacy Downloads', icon: <HistoryIcon />, link: NavigatorData.legacyDownloadProductUrl }
  ];

}

